import BlokWrap from "@/components/bloks/BlokWrap";
import type { BlokBanner } from "@/storyblok";
import { type BlokProps, StoryblokComponent } from "@frend-digital/storyblok";
import { AssetBlok, sizes } from "../Asset";
import { MediaLink, hasMediaLink } from "../MediaLink";

import { SegmentControl } from "@/components/SegmentControl";
import { RichTextRender } from "@/components/ui/RichTextRender";
import { clsx } from "@frend-digital/ui";
import styles from "./Banner.module.css";

export const BannerBlok = ({
	blok,
	preview,
	className,
}: BlokProps<BlokBanner> & { className?: string }) => {
	const position = blok.position || "left";
	const textColor = blok.textColor === "white" ? styles.white : styles.black;

	return (
		<SegmentControl segments={blok}>
			<BlokWrap editable={blok} asChild>
				<div
					className={clsx(styles.root, className)}
					data-media-linked={hasMediaLink(blok.mediaLink) || undefined}
					data-height={(blok.height || undefined) as "small" | "medium" | "large" | undefined}
					data-height-mobile={
						(blok.heightMobile || undefined) as "small" | "medium" | "large" | undefined
					}
				>
					<div className={clsx(styles.content, styles[position])}>
						<RichTextRender blok={blok.title!} preview={preview} className={textColor} />

						{blok.button?.map((button) => (
							<StoryblokComponent
								key={button._uid}
								blok={button}
								preview={preview}
								trackingContext={{ type: blok.component, id: blok._uid }}
							/>
						))}
					</div>
					<div className={styles.imageContainer}>
						<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
							<AssetBlok priority source={blok.media!} sizes={sizes(100, 80)} />
						</MediaLink>
					</div>
				</div>
			</BlokWrap>
		</SegmentControl>
	);
};
